<template lang="pug">
#bloco-inserir-contrato-originacao-planilha
    el-card(:body-style='{ padding: "20px" }')
        .bloco-inserir-contrato-originacao-mensagem-informativa_texto
            span Para agilizar seu processo, você pode adicionar mais de um contrato de uma só vez através de uma planilha.
            span Ela deve conter os seguintes campos:

        .bloco-inserir-contrato-originacao-planilha__linha
            div
                ul.bloco-inserir-contrato-originacao-planilha__campos
                    li Número do contrato
                    li Cultura
                    li Safra
                    li Volume contratado (t)
                    li Volume recebido (t)
                    li Data do contrato
                    li BP Cliente
                    li Fornecedor
                    li CNPJ fornecedor
                    li Segmento
                    li Canal
                    li Estado
                    li Município
                    li Regional
                    li Gerente regional
                    li Gerente comercial
                    li Gestor territorial
            .bloco-inserir-contrato-originacao-planilha__upload
                el-upload(
                    action='#',
                    :auto-upload='false'
                    :on-change='enviarPlanilha',
                    :on-exceed='onExceed',
                    :file-list='fileList'
                    :limit='1',
                    drag,
                    ref='uploadPlanilhaContratoOriginacao'
                )
                    i.el-icon-upload
                    .el-upload__text Arraste o arquivo aqui ou <em>clique para subir</em>

        div(v-if='dadosLote')
            hr
            div
                el-descriptions(:column='5', direction='vertical')
                    template(slot='title')
                        span.bloco-inserir-contrato-originacao-planilha-lote__titulo Dados do último lote
                            .bloco-inserir-contrato-originacao-planilha-lote__atualizar(v-if="dadosLote && dadosLote.statusCodigo !== 'PROCESSADO' && dadosLote.statusCodigo !== 'PROCESSADO_COM_ERRO'")
                                el-tooltip(
                                    effect='dark'
                                    content='Atualizar o processamento'
                                    placement='top'
                                )
                                    BaseButton(
                                        type='primary',
                                        size='mini'
                                        icon='el-icon-refresh',
                                        @click.native='atualizarProcessamento()'
                                    )
                    el-descriptions-item(contentClassName='bloco-inserir-contrato-originacao-planilha-lote__importada')
                        template(slot='label')
                            span.bloco-inserir-contrato-originacao-planilha-lote__label Planilha importada
                        el-tooltip(
                                effect='dark'
                                :content='dadosLote.planilha'
                                placement='top'
                            )
                            span {{ dadosLote.planilha }}
                    el-descriptions-item(v-if='dadosLote.planilhaErro')
                        template(slot='label')
                            span.bloco-inserir-contrato-originacao-planilha-lote__label Planilha com erro
                        BaseButton(
                            type='primary',
                            size='mini'
                            icon='el-icon-download',
                            @click='fazerDownload(dadosLote.id)'
                        ) Fazer download
                    el-descriptions-item
                        template(slot='label')
                            span.bloco-inserir-contrato-originacao-planilha-lote__label Data cadastro
                        | {{ dadosLote.dataCadastro }}
                    el-descriptions-item
                        template(slot='label')
                            span.bloco-inserir-contrato-originacao-planilha-lote__label Última atualização
                        | {{ dadosLote.dataAtualizacao }}
                    el-descriptions-item(label='Status')
                        template(slot='label')
                            span.bloco-inserir-contrato-originacao-planilha-lote__label Status
                        el-tag(v-if="dadosLote.statusCodigo === 'EM_PROCESSAMENTO'" type='info')
                        el-tag(v-if="dadosLote.statusCodigo === 'EM_PROCESSAMENTO'" type='info')
                            i.el-icon-loading(v-if="dadosLote.statusCodigo === 'EM_PROCESSAMENTO'")
                            | {{ dadosLote.status }}
                        el-tag(v-if="dadosLote.statusCodigo === 'PROCESSADO_COM_ERRO'" type='warning') {{ dadosLote.status }}
                        el-tag(v-if="dadosLote.statusCodigo === 'PROCESSADO'" type='success') {{ dadosLote.status }}
                 
</template>

<script>
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'BlocoInserirContratoOriginacaoPlanilha',

    components: {
        BaseButton
    },

    emits: ['atualizarTabelaContratosNaoEnviados'],

    data() {
        return {
            fileList: [],
            dadosLote: null
        };
    },
    mounted() {
        this.buscarDadosLote();
    },
    methods: {
        onExceed() {
            this.$notify.warning({
                message: 'Só é permitido o upload de um arquivo por vez.',
                position: 'top-left'
            });
        },

        async enviarPlanilha(planilha) {
            if (this.dadosLote && this.dadosLote.statusCodigo === 'EM_PROCESSAMENTO') {
                this.$notify.warning({
                    message: 'Não é possivel realizar um novo cadastro, pois existe um em processamento.'
                });
                this.$refs.uploadPlanilhaContratoOriginacao.clearFiles();
                return false;
            }

            if (planilha.size > 15000000) {
                this.$notify.warning({
                    message: 'Esse arquivo ultrapassa 15MB.'
                });
                this.$refs.uploadPlanilhaContratoOriginacao.clearFiles();
                return false;
            }
            let extension = planilha.name.split('.').pop().toLowerCase();

            if (extension !== 'xlsx') {
                this.$notify.error({
                    message: 'Apenas arquivos com a extensão XLSX são suportados.'
                });
                this.$refs.uploadPlanilhaContratoOriginacao.clearFiles();
                return false;
            }

            try {
                this.$notify.success({
                    message: 'Arquivo está sendo enviado.'
                });
                await ContratoOriginacaoService.cadastrarViaPlanilha(planilha);
                this.$notify.success({
                    message: 'Arquivo enviado com sucesso. O processamento será concluído em breve.'
                });
                this.buscarDadosLote();
            } catch (error) {
                this.$notify.error({
                    message: 'Erro ao realizar upload do arquivo.'
                });
            }
            this.$refs.uploadPlanilhaContratoOriginacao.clearFiles();
        },

        async buscarDadosLote() {
            try {
              const { data } = await ContratoOriginacaoService.buscarDadosLoteEmpresa();
              if (data) {
                  this.dadosLote = data;
              }
            } catch (error) {
                this.$notify.error({
                    message: 'Erro ao buscar dados de processamento.'
                });
            }
        },

        fazerDownload(id) {
            ContratoOriginacaoService.downloadPlanilhaComErro(id)
                .then(() => {
                    this.$notify.success({
                        message: 'Download realizado com sucesso!'
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: 'Erro ao realizar download!'
                    });
                });
        },

        atualizarProcessamento() {
            this.buscarDadosLote();
            this.$emit('atualizarTabelaContratosNaoEnviados');
            this.$notify.success({
                message: 'O processamento foi atualizado.'
            });
        }
    }
};
</script>

<style lang="scss">
#bloco-inserir-contrato-originacao-planilha {
    .bloco-inserir-contrato-originacao-planilha__linha {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .bloco-inserir-contrato-originacao-planilha__campos {
            width: 500px;
            column-count: 2;

            li::after {
                content: ' *';
                color: red;
            }
        }
    }

    .bloco-inserir-contrato-originacao-mensagem-informativa_texto {
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        margin-bottom: 20px;
    }

    .bloco-inserir-contrato-originacao-planilha__upload {
        width: 100%;
        i {
            color: var(--primary);
            font-size: 30px;
        }
    }

    .bloco-inserir-contrato-originacao-planilha-lote__titulo {
        font-size: 16px;
        font-weight: bold;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .bloco-inserir-contrato-originacao-planilha-lote__importada {
        display: inline-block;
        width: 200px;
        white-space: nowrap;
        overflow: hidden !important;
        text-overflow: ellipsis;
        padding-top: 5px;
    }

    .bloco-inserir-contrato-originacao-planilha-lote__label {
        font-weight: bold;
        color: var(--primary);
    }

    .bloco-inserir-contrato-originacao-planilha-lote__atualizar {
        margin-left: 10px;
    }

    .el-icon-loading {
        font-size: 15px;
        color: var(--primary);
        margin-right: 5px;
    }

    .el-upload-list__item-name [class^=el-icon] {
        height: 100% !important;
        margin-right: 7px !important;
        color: #909399 !important;
        line-height: inherit !important;
        font-size: 14px !important;
    }

    .el-upload-dragger:hover {
        border-color: var(--primary);
    }

    .el-upload-dragger {
        background-color: #f3f3f3;
    }
}
</style>
